import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSiteContext } from "../../context/SiteContext";
import requests from "../../services/httpServices";

export default function SsoLanding() {
  const navigate = useNavigate();
  const { setToken, setIsAuthenticated, setUser } = useSiteContext();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");

    if (!token) {
      navigate("/login", { replace: true });
      return;
    }

    localStorage.setItem("token", token);

    requests
      .get("/auth/profile")
      .then((res) => {
        const user = res?.data || res?.user || null;
        if (user) {
          localStorage.setItem("user", JSON.stringify(user));
          setUser(user);
        }
        setToken(token);
        setIsAuthenticated(true);
        navigate("/dashboard", { replace: true });
      })
      .catch(() => {
        localStorage.removeItem("token");
        navigate("/login", { replace: true });
      });
  }, [navigate, setToken, setIsAuthenticated, setUser]);

  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        background: "linear-gradient(135deg,#060621 0%,#0a0a2e 50%,#060621 100%)",
        color: "#ffffff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontFamily: "'DM Sans', sans-serif",
        fontSize: 16,
      }}
    >
      Signing you in…
    </div>
  );
}
